import { HUText } from "@modules/ui/components/huText"
import Line from "@modules/ui/components/line"
import { useTheme } from "styled-components"
import { v4 as uuidv4 } from 'uuid';

const MAX_LINES = 8 // Maximum number of lines, after this max number, the lines will be slipted in two columns

/**
 * Composant for render chart with lines in the Training page
 * @param number
 * @param date
 * @returns
 */
const HuLines = ({ number, date }: { number: number; date: string }) => {
  const theme = useTheme()

  return (
    <div className="flex flex-column justify-content-end align-items-center h-full w-3">
      <div className="mb-2">
        <HUText color={theme.mainBlack} fontStyle="TM">
          {number}
        </HUText>
      </div>
        {number <= MAX_LINES ? (
          <div className="flex flex-column gap-1 w-full">
          {Array.from({ length: number }).map((_) => (
            <Line key={uuidv4()} color={theme.mainBlack} strokeWidth={3} className="m-0 rounded-full" />
          ))}
          </div>
        ) : (
          <>
           <div className="flex gap-1 w-full">
            <div className="flex flex-column gap-1 w-6">
              {Array.from({ length: Math.ceil(number / 2) }).map((_) => (
                <Line key={uuidv4()} color={theme.mainBlack} strokeWidth={3} className="m-0 rounded-full" />
              ))}
            </div>
            <div className="flex flex-column-reverse gap-1 w-6">
              {Array.from({ length: Math.floor(number / 2) }).map((_) => (
                <Line key={uuidv4()} color={theme.mainBlack} strokeWidth={3} className="m-0 rounded-full" />
              ))}
            </div>
            </div>
          </>
        )}

      <div className="mt-1">
        <HUText color={theme.mainBlack} fontStyle="BS">
          {date}
        </HUText>
      </div>
    </div>
  )
}

export default HuLines
